<template>
  <v-layout class="justify-center">
    <v-flex xs12 sm6 class="errors" v-if="errors.length">
      <v-card v-for="(error, i) in errors" :key="i" class="error ma-1">
        <v-container>
          <v-layout row class="align-center">
            <v-flex xs1 class="pa-2">
              <v-icon large class="pa-2 ml-1 mr-2">warning</v-icon>
            </v-flex>
            <v-flex xs11 class="pa-2 mx-4">
              <div class="error_message" v-html="error.msg"></div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import store from "../../store";

export default {
  name: "ShowErrors",
  store: store,
  computed: {
    errors() {
      return store.state.errors;
    }
  }
};
</script>
